import { ref, unref } from 'vue'
import { STORAGE_NAMES, storageKey } from '~/utils/storageKey'

/**
 * 页面级移动搜索历史。组件只展示数据，存储策略由调用方通过该 composable 组合。
 * @param {string|import('vue').Ref<string>} scope
 */
export function useLocalMobileSearchHistory(scope) {
  const historyItems = ref([])

  const getStorageKey = () =>
    storageKey(`${STORAGE_NAMES.MOBILE_SEARCH_HISTORY}_${String(unref(scope) || 'custom')}`)

  const loadHistory = () => {
    if (!import.meta.client) return
    try {
      historyItems.value = JSON.parse(localStorage.getItem(getStorageKey()) || '[]')
    } catch {
      historyItems.value = []
    }
  }

  const saveHistory = () => {
    if (!import.meta.client) return
    localStorage.setItem(getStorageKey(), JSON.stringify(historyItems.value))
  }

  const addHistory = (keyword) => {
    const value = String(keyword || '').trim()
    if (!value) return
    historyItems.value = [value, ...historyItems.value.filter((item) => item !== value)].slice(
      0,
      20
    )
    saveHistory()
  }

  const clearHistory = () => {
    historyItems.value = []
    saveHistory()
  }

  return {
    historyItems,
    loadHistory,
    addHistory,
    clearHistory,
  }
}
